import { render, staticRenderFns } from "./QuantificationRecord.vue?vue&type=template&id=e4ac7374&scoped=true"
import script from "./QuantificationRecord.vue?vue&type=script&lang=js"
export * from "./QuantificationRecord.vue?vue&type=script&lang=js"
import style0 from "./QuantificationRecord.vue?vue&type=style&index=0&id=e4ac7374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ac7374",
  null
  
)

export default component.exports